import React, {useState} from 'react';
import GenericModal from 'library/components/generic-modal';
import { withRouter } from 'react-router';
import { resolve } from 'library/helpers/path-resolver';
import useForm from 'library/hooks/use-form';
import {SearchRow, EmailSearchInput, SearchResults} from 'apps/admin/components/survey-connector/styles';
import Query from 'apps/admin/util/query';
import { jsonToInputParams } from 'library/util/graph';
import { NotificationRender } from 'library/components/notification';
import { duplicateAssessmentMutation } from 'apps/admin/queries/duplicateAssessmentMutation';

const SurveyConnector = ({history, match, reload_graph}) => {
  const {values, handleChange} = useForm({});
  const [assessments, setAssessments] = useState([]);

  const handleSearch = async () => {
    const {data} = await Query(`{
      user (${jsonToInputParams({email: values.email})}) {
        id,
        assessments(recent: false) {
          id
          token
          state
          created_at
          completed_at
          progress
          scored
          version
          validity_score
          validity_errors
        }
      }
    }`);
    setAssessments(resolve(data, 'user/assessments', []));
  };

  const copyAssessment = async (assessmentId, remove_from_original_user = false) => {
    const params = {
      assessmentId,
      userId: Number(resolve(match, 'params/user_id', null)),
      removeFromOriginalUser: remove_from_original_user
    };

    try {
      const {data} = await duplicateAssessmentMutation(params);
      const success = resolve(data, 'duplicate_assessment/success', false);
      if(success) {
        NotificationRender('success', 'The assessment was successfully duplicated');
        await reload_graph();
        history.goBack();
      } else {
        NotificationRender('error', 'There was an error');
      }
    } catch (e) {
      NotificationRender('error', 'There was an error');
      console.error(e);
    }
  };

  return (
    <GenericModal active toggleActive={() => history.goBack()}>
      <SearchRow>
        <EmailSearchInput name='email' placeholder='Search by email' value={values.email} onChange={handleChange} />
        <button type='button' onClick={handleSearch}>Search</button>
      </SearchRow>
      <SearchResults>
        <table>
          <thead>
            <tr>
              <td>Assessment ID</td>
              <td>State</td>
              <td>Progress</td>
              <td>Completed At</td>
              <td></td>
            </tr>
          </thead>
          {assessments.length > 0 ?
            <tbody>
              {assessments.map((assessment, i) => (
                <tr key={i}>
                  <td>{assessment.id}</td>
                  <td>{assessment.state}</td>
                  <td>{assessment.progress}</td>
                  <td>{assessment.completed_at}</td>
                  <td><button type='button' onClick={() => copyAssessment(assessment.id, true)}>Copy and Remove</button></td>
                  <td><button type='button' onClick={() => copyAssessment(assessment.id)}>Copy</button></td>
                </tr>
              ))}
            </tbody>
            : null
          }
        </table>
      </SearchResults>
    </GenericModal>
  );
};

export default withRouter(SurveyConnector);
